import { getScrollableContainer } from '../utils/helpers';

const mainContainer = getScrollableContainer();

const scrollPage = ({
  destination = 0,
  duration = 400,
  scrollableArea = mainContainer,
  callback,
} = {}) => {
  const isWindow = scrollableArea === window;

  const getYOffset = () => scrollableArea[isWindow ? 'pageYOffset' : 'scrollTop'];

  const documentHeight = isWindow ? document.body.offsetHeight : scrollableArea.scrollHeight;
  const windowHeight = scrollableArea[isWindow ? 'innerHeight' : 'offsetHeight'];
  const destinationOffsetToScroll = Math.round(
    (documentHeight - destination) < windowHeight ? (documentHeight - windowHeight) : destination,
  );

  const yOffset = getYOffset();
  const startTime = performance.now();

  // Handle cancelation edge cases
  let prevYOffset;
  let offsetList = [];
  const shouldCancel = (currOffset) => {
    if (currOffset === prevYOffset) offsetList = [...offsetList, currOffset];
    return offsetList.length >= 5;
  };

  const scroll = () => {
    const time = Math.min(1, ((performance.now() - startTime) / duration));
    scrollableArea.scrollTo(0, Math.ceil((time * (destinationOffsetToScroll - yOffset)) + yOffset));

    if (getYOffset() === destinationOffsetToScroll || shouldCancel(getYOffset())) {
      if (callback) callback();
      return;
    }

    prevYOffset = getYOffset();
    requestAnimationFrame(scroll);
  };

  scroll();
};

export default scrollPage;

export const horizontalScrollTo = ({
  destination = 0,
  scrollableArea,
  duration = 400,
  callback,
} = {}) => {
  const getXOffset = () => scrollableArea.scrollLeft;

  const { scrollWidth, offsetWidth } = scrollableArea;
  const destinationOffsetToScroll = Math.round(
    (scrollWidth - destination) < offsetWidth ? (scrollWidth - offsetWidth) : destination,
  );

  const xOffset = getXOffset();
  const startTime = performance.now();

  // Handle cancelation edge cases
  let prevXOffset;
  let offsetList = [];
  const shouldCancel = (currOffset) => {
    if (currOffset === prevXOffset) offsetList = [...offsetList, currOffset];
    return offsetList.length >= 5;
  };

  const scroll = () => {
    const time = Math.min(1, ((performance.now() - startTime) / duration));
    scrollableArea.scrollTo(Math.ceil((time * (destinationOffsetToScroll - xOffset)) + xOffset), 0);

    if (getXOffset() === destinationOffsetToScroll || shouldCancel(getXOffset())) {
      if (callback) callback();
      return;
    }

    prevXOffset = getXOffset();
    requestAnimationFrame(scroll);
  };

  scroll();
};
